<script setup lang="ts">
import { Toaster } from 'vue-sonner'

import { useBreakpoints } from './composables/use-breakpoint'

import { useHead, useSeoMeta, onMounted, ref } from '#imports'
import { useRuntimeConfig } from '#app/nuxt'

const { activeBreakpoint } = useBreakpoints()
const {
  public: { appEnvironment },
} = useRuntimeConfig()

useHead({
  htmlAttrs: { lang: 'en' },
  link: [{ rel: 'icon', href: '/favicon.png' }],
  meta: [
    {
      name: 'viewport',
      content: 'viewport-fit=cover, width=device-width, initial-scale=1.0, user-scalable=no',
    },
    { key: 'theme-color', name: 'theme-color', content: '#778E57' },
    appEnvironment === 'production'
      ? {}
      : {
          name: 'robots',
          content: 'noindex',
        },
  ],
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} | SellMyLivestock - The Online Livestock Marketplace` : 'SellMyLivestock - The Online Livestock Marketplace'
  },
})

useSeoMeta({
  description: 'Buy and sell livestock, cattle, sheep on the online marketplace with SellMyLivestock. Connect with over 170,000 users across the UK',
  ogImage: 'https://sellmylivestock.com/img/open-graph.2574f6dd.jpg',
  twitterImage: 'https://sellmylivestock.com/img/open-graph.2574f6dd.jpg',
  twitterCard: 'summary_large_image',
})

// Setting activeBreakpoint as a class on the layout element will cause hydration issues with SSR
// So we only add the class once the component is mounted on the client side
const isMounted = ref(false)

onMounted(() => {
  if (import.meta.client) {
    isMounted.value = true
  }
})
</script>

<template>
  <div :class="isMounted ? activeBreakpoint : undefined">
    <NuxtLoadingIndicator />

    <!-- <NuxtErrorBoundary>
      <template #error="{ error }">
        <p>{{ $ts('anErrorOccured') }} {{ error }}</p>
      </template>
    </NuxtErrorBoundary> -->

    <NuxtPage />

    <ModalProvider />

    <Toaster />
  </div>
</template>
